import { pdfjs } from 'react-pdf';

/**
 * The pdf.js worker, from our own origin. Import this once, anywhere a PDF is rendered.
 *
 * `GlobalWorkerOptions.workerSrc` is a single global, and four modules were each assigning it at
 * import time — three of them to unpkg. Whichever the bundler happened to evaluate last won, so
 * fixing one of them changed nothing: the deployed bundle still requested
 * `unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs` (JT1-1491, 2026-09-10).
 *
 * A cross-origin worker script cannot be loaded directly, so pdf.js fetches it and wraps it in a
 * `blob:` URL — and the CloudFront CSP allows `blob:` under `default-src` but not under
 * `script-src`, which is what `worker-src` falls back to. Every PDF preview died there and fell
 * through to the Office viewer, which renders as a broken frame.
 *
 * `new URL(..., import.meta.url)` makes Vite emit the worker as a hashed asset of this build, so it
 * is same-origin, no blob is created, and the CSP is not involved. It also removes a hard runtime
 * dependency on unpkg being up for a core feature.
 */
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();
